module.exports = __webpack_public_path__ + "img/login_slide_02.d80d8b00.webp";